import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

/* istanbul ignore next */
export default universal(
    universalImport({
        chunkName: () => 'ErrorFullPage',
        path: () => path.join(__dirname, './ErrorFullPage'),
        resolve: () => require.resolveWeak('./ErrorFullPage'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "ErrorFullPage" */ './ErrorFullPage')]).then(
                (proms) => proms[0]
            ),
    })
);
